import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/feature/SchemaOrg";
import HeroBanner from "./components/HeroBanner";
import FeaturedComics from "./components/FeaturedComics";
import LatestUpdates from "./components/LatestUpdates";
import CategorySection from "./components/CategorySection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: "番茄漫画",
          url: "https://fanqiecomic.com",
          description: "番茄漫画免费漫画全集大全，提供完结连载热门韩漫、日漫、国漫高清免费在线阅读，追更最新话，支持离线下载缓存，海量漫画免费看。",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://fanqiecomic.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "番茄漫画",
          url: "https://fanqiecomic.com",
          description: "国内领先的免费漫画在线阅读平台",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "400-888-6666",
            contactType: "customer service",
            availableLanguage: "Chinese",
          },
        }}
      />
      <Navbar />
      <main className="pt-16">
        <HeroBanner />
        <FeaturedComics />
        <LatestUpdates />
        <CategorySection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}